import type { App, Holding, Initiative } from '../lib/types';
import AppCard from './AppCard';

interface Props {
  holding: Holding;
  apps: App[];
  initiatives: Initiative[];
  onEditInitiative: (app_id: string, initiative: Initiative) => void;
  onAddInitiative: (app_id: string) => void;
  onEditApp: (app: App) => void;
  onAddApp: () => void;
}

export default function HoldingColumn({
  holding, apps, initiatives,
  onEditInitiative, onAddInitiative, onEditApp, onAddApp,
}: Props) {
  const dot = holding.color || '#6366F1';
  return (
    <section className="glass rounded-2xl p-5">
      <header className="flex items-center gap-3 mb-4">
        <span
          className="w-2.5 h-2.5 rounded-full"
          style={{ background: dot, boxShadow: `0 0 14px ${dot}` }}
        />
        <h2 className="text-base font-semibold tracking-tight">{holding.name}</h2>
        {holding.description && (
          <span className="text-xs text-ink-400 truncate">{holding.description}</span>
        )}
        <button className="btn ml-auto text-xs" onClick={onAddApp}>+ App</button>
      </header>

      <div className="space-y-4">
        {apps.length === 0 && (
          <div className="text-xs text-ink-400 border border-dashed border-white/10 rounded-lg p-4 text-center">
            Sin apps. <button className="underline" onClick={onAddApp}>Agregar la primera</button>
          </div>
        )}
        {apps.map((app) => (
          <AppCard
            key={app.id}
            app={app}
            initiatives={initiatives.filter((i) => i.app_id === app.id)}
            onEditInitiative={(ini) => onEditInitiative(app.id, ini)}
            onAddInitiative={() => onAddInitiative(app.id)}
            onEditApp={() => onEditApp(app)}
          />
        ))}
      </div>
    </section>
  );
}
